import { getCurrentDate, getCurrentTime, getDisplayDate } from '../../utils/DateUtils';

export function getInitialWorkScheduleFormState() {
  return {
    schedule_date: getCurrentDate(),
    delivery_date: getCurrentDate(),
    delivery_time: getCurrentTime(),
    is_extra_shut_required: 'false',
    cube_mould_test_place: 'plant',
    is_name_req: 'false',
    status: 'true',
  };
}

export function applySalesOrderScheduleDefaults(salesOrder) {
  if (!salesOrder?.id) {
    return {};
  }
  const updates = {};
  if (salesOrder.validity_date) {
    updates.validity_date = getDisplayDate(salesOrder.validity_date);
  }
  if (salesOrder.delivery_date) {
    updates.delivery_date = getDisplayDate(salesOrder.delivery_date);
  }
  return updates;
}

export function mapCompanyPlants(company) {
  return (company?.plants || []).map((plant) => ({
    value: plant.id,
    label: plant.alias,
  }));
}

export function pickDefaultPlantId(plants) {
  if (!plants?.length) {
    return '';
  }
  if (plants.length === 1) {
    return String(plants[0].value);
  }
  return '';
}
